import instance from '@/utils/axios';

/**
 * @param {{busiType: number}} params
 * @returns
 */
export function getTrackOffice(params) {
  return instance.get('/auth/trackOffice', { params });
}

/**
 * @param {{id:string, nodeType: number}} params
 * @returns
 */
export function trackDevice(params) {
  return instance.get('/deviceTrack/trackDevice', { params });
}

/**
 * @param {{sn:string}} params
 * @returns
 */
export function beginTrack(sn) {
  return instance.get('/deviceTrack/beginTrack', { params: { sn } });
}

/**
 * @param {{sn:string}} params
 * @returns
 */
export function stopTrack(sn) {
  return instance.get('/deviceTrack/stopTrack', { params: { sn } });
}

/**
 *
 * @param {{officeId: string,sns: string,beginTime: number,endTime: number,playSpeed: number }} data
 * @returns {Promise<[]>}
 */
export function getReplayList(data) {
  return instance.post('/deviceTrack/replayList', data);
}

/** @typedef {id:string, beginTime: number; endTime: number} replayParam */

/**
 * 回放
 * @param {replayParam} data
 * @returns {Promise<[]>}
 */
export function trackReplay(data) {
  return instance.post('/deviceTrack/replay', data);
}

export function getTrackParam(sn) {
  return instance.get('/deviceTrack/getDeviceTrackParams', { params: { sn } });
}

/**
 * 设置地图参数
 * @param {{ sn:string, devicemapParamItems: { id: string, itemCode: string, itemName: string, itemSort: number,linkId, mapType:string, remarks: string, value: string } }} data
 * @returns {any}
 */
export function setTrackParam(data) {
  return instance.post('/deviceTrack/saveDeviceTrackParams', data);
}
